// Plugins
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/blur-up/ls.blur-up';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'what-input';

// Modules
import cookieBanner from './modules/cookie-banner';
import header from './modules/header';
// import scroll from './modules/scroll';
import form from './modules/form';
import modal from './modules/modal';
import shop from './modules/shop';
import expandable from './modules/expandable';
import slider from './modules/slider';
import story from './modules/story';
import mouseCursor from './modules/mouse-cursor';
import showMore from './modules/show-more';
import newsletterPopup from './modules/newsletter-popup';
import notifications from './modules/notifications';
import video from './modules/video';

// Get viewport units
const calcViewportUnits = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  const vw = window.innerWidth * 0.01;
  document.documentElement.style.setProperty('--vw', `${vw}px`);

  const pageHeight = document.querySelector('main').offsetHeight;
  document.documentElement.style.setProperty('--pageH', `${pageHeight}px`);
};

// Get Scrollbar width
const getSBWidth = () => {
  const sb = window.innerWidth - document.body.clientWidth;
  document.documentElement.style.setProperty('--sb', `${sb}px`);
  document.body.style.overflow = '';
};

window.addEventListener('resize', () => {
  getSBWidth();
  calcViewportUnits();
});

// A11Y
const initModals = () => {
  const modals = document.querySelectorAll('[data-modal]');

  modals.forEach(modal => {
    const focusTrap = modal.querySelector('[data-focus-trap]');
    const focusLoop = modal.querySelector('[data-focus-loop]');

    const onTrapFocus = () => {
      focusLoop.focus();
    };

    const observer = new MutationObserver(() => {
      const isOpen =
        modal.getAttribute('aria-expanded') == 'true' ||
        modal.getAttribute('aria-hidden') == 'false';

      if (isOpen && focusTrap && focusLoop) {
        focusTrap.addEventListener('focus', onTrapFocus);
      } else if (!isOpen && focusTrap && focusLoop) {
        focusTrap.removeEventListener('focus', onTrapFocus);
      }
    });

    observer.observe(modal, { attributes: true });
  });
};

const initAll = () => {
  // Modules
  lazySizes.init();
  header();
  // scroll();
  form();
  modal();
  shop();
  expandable();
  slider();
  story();
  mouseCursor();
  showMore();
  newsletterPopup();
  cookieBanner();
  notifications();
  video();

  // Layout
  calcViewportUnits();
  getSBWidth();

  // A11Y
  initModals();

  document.body.classList.add('js');
};

if (document.readyState !== 'loading') {
  initAll();
} else {
  document.addEventListener('DOMContentLoaded', () => initAll());
}
